const tinyHeader = (editor) => {
  if (!editor.dom) return;

  const container = editor.getContainer();

  const header = container.querySelector(".tox-editor-header");
  const menubar = header.querySelector(".tox-menubar");
  if (menubar) {
    // Avoid duplicate injection
    if (menubar.querySelector(".my-custom-menu")) return;

    // Inject Brand Logo "Vedas" on the left
    if (!menubar.querySelector(".custom-brand")) {
      const brandDiv = document.createElement("div");
      brandDiv.classList.add("custom-brand");
      brandDiv.style.display = "flex";
      brandDiv.style.alignItems = "baseline";
      brandDiv.style.gap = "2px";
      brandDiv.style.marginRight = "24px";
      brandDiv.style.marginLeft = "4px";
      brandDiv.innerHTML = `
        <img src="/vedas/images/logo.svg" alt="Vedas" style="height:23px; display:block; margin-bottom:2px;" />
      `;
      menubar.insertBefore(brandDiv, menubar.firstChild);
    }

    const newDiv = document.createElement("div");
    newDiv.classList.add("my-custom-menu");
    newDiv.innerHTML = `
      <div class="t-menu" style="display:flex; align-items:center;">
        <div class="mode-toggle-group" style="display:inline-flex; align-items:center; background:#F1F2F6; padding:2px; border-radius:6px; margin-right:12px; border:1px solid #E2E4E9;">
          <button type="button" class="mode-btn mode-btn-visual" style="display:flex; align-items:center; gap:5px; padding:3px 9px; font-size:11px; font-weight:600; border-radius:4px; border:none; background:#FFFFFF; color:#4F46E5; box-shadow:0 1px 2px rgba(0,0,0,0.06); cursor:pointer;" title="Current: Visual TinyMCE Editor">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
            <span>Visual</span>
          </button>
          <button type="button" class="mode-btn mode-btn-xml" style="display:flex; align-items:center; gap:5px; padding:3px 9px; font-size:11px; font-weight:500; border-radius:4px; border:none; background:transparent; color:#6B6B76; cursor:pointer;" title="Switch to XML Source Editor">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>
            <span>XML</span>
          </button>
          <button type="button" class="mode-btn-format-xml" style="display:none; align-items:center; gap:4px; padding:3px 8px; font-size:11px; font-weight:500; border-radius:4px; border:none; background:transparent; color:#4F46E5; cursor:pointer;" title="Auto-format XML tag indentation">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="21" y1="10" x2="3" y2="10"/><line x1="21" y1="6" x2="3" y2="6"/><line x1="21" y1="14" x2="3" y2="14"/><line x1="21" y1="18" x2="3" y2="18"/></svg>
            <span>Format</span>
          </button>
        </div>
        <div data-custom-menu="downloadxml" class="t-head-menu">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#6B6B76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12M7 11l5 4 5-4M5 21h14"/></svg>
          <span>Download XML</span>
        </div>
        <div data-custom-menu="xml" class="t-head-menu">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#6B6B76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21V9M7 13l5-4 5 4M5 3h14"/></svg>
          <span>Upload XML</span>
        </div>
        <div data-custom-menu="upload" class="t-head-menu">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#6B6B76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3v5h5M14 3l5 5v11a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/></svg>
          <span>Upload File</span>
        </div>
        <div data-custom-menu="help" class="t-head-menu">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#6B6B76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M9.5 9a2.5 2.5 0 1 1 3.2 2.4c-.7.3-1.2.9-1.2 1.6v.4"/><circle cx="12" cy="17" r=".6" fill="#6B6B76"/></svg>
          <span>Help</span>
        </div>
      </div>
    `;
    menubar.appendChild(newDiv);

    const visualModeBtn = newDiv.querySelector(".mode-btn-visual");
    if (visualModeBtn) {
      visualModeBtn.addEventListener("click", function () {
        editor.execCommand("switchToVisual");
      });
    }

    const xmlModeBtn = newDiv.querySelector(".mode-btn-xml");
    if (xmlModeBtn) {
      xmlModeBtn.addEventListener("click", function () {
        editor.execCommand("switchToXml");
      });
    }

    const formatXmlBtn = newDiv.querySelector(".mode-btn-format-xml");
    if (formatXmlBtn) {
      formatXmlBtn.addEventListener("click", function () {
        editor.execCommand("formatXML");
      });
    }

    const uploadBtn = newDiv.querySelector('[data-custom-menu="upload"]');
    const xmlBtn = newDiv.querySelector('[data-custom-menu="xml"]');
    const downloadXmlBtn = newDiv.querySelector('[data-custom-menu="downloadxml"]');
    const helpBtn = newDiv.querySelector('[data-custom-menu="help"]');

    if (uploadBtn) {
      uploadBtn.addEventListener("click", function () {
        editor.execCommand("uploadDoc");
      });
    }
    if (xmlBtn) {
      xmlBtn.addEventListener("click", function () {
        editor.execCommand("uploadXML");
      });
    }
    if (downloadXmlBtn) {
      downloadXmlBtn.addEventListener("click", function () {
        editor.execCommand("downloadXML");
      });
    }
    if (helpBtn) {
      helpBtn.addEventListener("click", function () {
        editor.execCommand("helping");
      });
    }
  }
};

export { tinyHeader };
